import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { useTheme } from '@emotion/react';
import Button from './Button';
import Icon from './Icon';
import { jsx as ___EmotionJSX } from "@emotion/react";

const Close = _ref => {
  let {
    onClick,
    noContrast
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["onClick", "noContrast"]);

  const theme = useTheme();
  return ___EmotionJSX(Button, _extends({
    type: "reset",
    title: "Close",
    onClick: onClick,
    css: [{
      // 1. To align better with headers
      color: theme.fontColor.base,
      opacity: theme.opacity.base,
      width: '1em',
      height: '1em',
      transition: `opacity ${theme.timing.short} linear, transform ${theme.timing.short} linear`,
      '&:hover, &:focus': {
        opacity: 1,
        transform: 'scale(1.15)'
      }
    }, theme.settings.contrast.enable && !noContrast && {
      '.u-contrast &': {
        color: theme.contrast.base
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:Close;"]
  }, rest), ___EmotionJSX(Icon, {
    icon: "close",
    className: "CK__Close__Icon"
  }));
};

export default Close;